import { useEffect, useState, useMemo, useRef } from 'react';
import { cloneDeep } from 'lodash';
import { getDeepValue } from '../../../../utils/index';
import Menu from '../roaming-menu/roaming-menu';
import PanoMap from '../pano-map/pano-map';

interface IProps {
  moduleConfig: any;
  krpanoCurScene: string;
  krpanoCurRotate: number;
  defaultHouseTypeId: string;
  hideOtherContent: boolean;
  setKrpanoCurScene: (string) => void;
}

const PanoRoaming: React.FC<IProps> = (props) => {
  let { moduleConfig } = props;
  const { krpanoCurScene, setKrpanoCurScene, krpanoCurRotate, defaultHouseTypeId, hideOtherContent } = props;

  const getHouseIndexById = (houseTypeId: string) => {
    if (!houseTypeId) return 0;
    const groups = getDeepValue(moduleConfig, 'groups');
    const resIndex = groups?.findIndex((house) => house.id === houseTypeId);
    if (resIndex === '-1') {
      return 0;
    }
    return resIndex;
  };

  if (hideOtherContent) {
    moduleConfig = cloneDeep(moduleConfig);
    if (moduleConfig.groups?.length) {
      moduleConfig.groups = [moduleConfig.groups[getHouseIndexById(defaultHouseTypeId)]];
    }
  }

  const [currentHouseTypeIndex, setCurrentHouseTypeIndex] = useState<number>(getHouseIndexById(defaultHouseTypeId));
  const [currentFloorIndex, setCurrentFloorIndex] = useState<number>(0);
  const [currentSceneIndex, setCurrentSceneIndex] = useState<number>(0);

  const singleModule = useRef<boolean>(false);

  const currentHouseInfo =
    useMemo(() => getDeepValue(moduleConfig, `groups.${currentHouseTypeIndex}`), [currentHouseTypeIndex]) || {};

  const currentScene =
    useMemo(
      () => getDeepValue(moduleConfig, `groups.${currentHouseTypeIndex}.scenes.${currentSceneIndex}`),
      [currentSceneIndex, currentHouseTypeIndex],
    ) || '';

  const currentSceneInfo =
    useMemo(() => {
      const scenesMap = getDeepValue(moduleConfig, 'scenes');
      return scenesMap?.find((item) => item.name === currentScene);
    }, [currentScene]) || {};

  const handleChangeHouseType = (index, force = false) => {
    if (index === currentHouseTypeIndex && !force) return;
    setCurrentHouseTypeIndex(index);
    setCurrentSceneIndex(0);
  };

  const handleThumbClick = (index, force = false) => {
    if (!force && currentSceneIndex === index) return;
    const scenes = getDeepValue(moduleConfig, `groups.${currentHouseTypeIndex}.scenes.${index}`) || [];
    if (!scenes) return;
    setCurrentSceneIndex(index);
  };

  // 根据场景名获取houseTypeIndex、sceneIndex
  const getMenuIndex = (scene) => {
    const groups = getDeepValue(moduleConfig, 'groups') || [];
    let houseTypeIndex = groups.findIndex((item) => item.scenes?.includes(scene));
    if (houseTypeIndex === -1) {
      houseTypeIndex = 0;
    }
    const group = groups[houseTypeIndex];
    let sceneIndex = group?.scenes ? group.scenes.findIndex((item) => item === scene) : -1;
    if (sceneIndex === -1) {
      sceneIndex = 0;
    }
    return { houseTypeIndex, sceneIndex };
  };

  useEffect(() => {
    if (currentScene && currentScene !== krpanoCurScene) {
      setKrpanoCurScene(currentScene);
    }
  }, [currentScene]);

  useEffect(() => {
    if (!krpanoCurScene && krpanoCurScene !== currentScene) return;
    const { houseTypeIndex, sceneIndex } = getMenuIndex(krpanoCurScene);
    setCurrentHouseTypeIndex(houseTypeIndex);
    setCurrentSceneIndex(sceneIndex);
  }, [krpanoCurScene]);

  return (
    <div className='xsdj-roaming-menu'>
      <PanoMap
        moduleConfig={moduleConfig}
        sceneInfo={currentSceneInfo}
        houseInfo={currentHouseInfo}
        currentFloorIndex={currentFloorIndex}
        krpanoCurRotate={krpanoCurRotate}
        setKrpanoCurScene={setKrpanoCurScene}
      />
      <Menu
        singleModule={singleModule.current}
        moduleConfig={moduleConfig}
        currentPlotIndex={0}
        currentHouseTypeIndex={currentHouseTypeIndex}
        currentFloorIndex={currentFloorIndex}
        currentSceneIndex={currentSceneIndex}
        onClickHouseType={handleChangeHouseType}
        onClickScene={handleThumbClick}
      />
    </div>
  );
};

export default PanoRoaming;
